'use strict';

function InventoryManagementDataTransformService(bookingsIntakeTransformer, FlightClassGridTransformer) {
  var transformer = new FlightClassGridTransformer();
  function transform(serviceResponse) {
    var services = transformer.transform({
      domain: serviceResponse
    }, true);
    bookingsIntakeTransformer.createBookingsIntakeHtml(services);
    return services;
  }
  return {
    transform: transform
  };
}
InventoryManagementDataTransformService.$inject = ['BookingsIntakeTransformationService', 'FlightClassGridTransformerFactory'];
module.exports = InventoryManagementDataTransformService;